const Data = [
    {
        name: "Vageesh Tiwari",
        position: "Finance Head",
        imageUrl: "/assets/images/members/VageeshTiwari.jpg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/",
        email: "gywsociety@gmail.com"
    },
    {
        name: "K Nikhil Sathwik",
        position: "Finance Head",
        imageUrl: "/assets/images/members/KNikhilSathwik.png",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/",
        email: "gywsociety@gmail.com"
    },
    {
        name: "Debasish Tudu",
        position: "Finance Head",
        imageUrl: "/assets/images/members/DebasishTudu.jpg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/",
        email: "gywsociety@gmail.com"
    },

]

export default Data;